import { render, staticRenderFns } from "./DisplayDeliverier.vue?vue&type=template&id=3b2bf444&"
import script from "./DisplayDeliverier.vue?vue&type=script&lang=js&"
export * from "./DisplayDeliverier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports